import(/* webpackMode: "eager", webpackExports: ["Background"] */ "/vercel/path0/src/components/ui/background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DebtChart"] */ "/vercel/path0/src/components/ui/debt-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/src/components/ui/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoldReservesAnalysisDialog"] */ "/vercel/path0/src/components/ui/gold-reserves-analysis-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoldReservesChart"] */ "/vercel/path0/src/components/ui/gold-reserves-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoldReservesGDPChart"] */ "/vercel/path0/src/components/ui/gold-reserves-gdp-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoldReservesTable"] */ "/vercel/path0/src/components/ui/gold-reserves-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/ui/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/src/components/ui/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarqueeDemo"] */ "/vercel/path0/src/components/ui/marquee-demo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NationalDebtAnalysisDialog"] */ "/vercel/path0/src/components/ui/national-debt-analysis-dialog.tsx");
